<template v-slot:default="{ isActive }">
    <v-dialog
      v-model="dialog"
      width="90rem"
      class="layer-popup"
      scrollable
    >
      <v-card>
        <!--content-->
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="pop-title">{{t('message.participationTarget')}}</div>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click.stop="dialog = false"
          ></v-btn>
        </v-card-title>

        <!--content-->
        <v-card-text class="target-pop-group ty01">
          <div class="dv-ty01">
            <div class="inner scrollbar">
              <div class="form-group col-ty">
                <div class="text-title">평가자</div>
                <!--form-row-->
                <div class="form-row" v-if="popupType == '2'">
                  <div class="row">
                    <div class="col">
                      <c-Input v-model="memberId" v-bind="InputName" :name="'memberId'" class="size02" />
                    </div>
                    <div class="col">
                      <Select v-model="posIdx" v-bind="selectPos"/>
                    </div>
                    <div class="col">
                      <Select v-model="deptIdx" v-bind="selectDept"/>
                    </div>
                    <div class="col">
                      <Select v-model="shiftYn" v-bind="selectShift"/>
                    </div>
                    <div class="col">
                      <Select v-model="targetYn" v-bind="selectTarget"/>
                    </div>
                    <div class="col">
                      <Select v-model="headYn" v-bind="selectHead"/>
                    </div>
                  </div>
                </div>
                <div class="text-total">{{memberCnt}}{{t('message.selectedCount')}}</div>
              </div>
              <div class="selected-group2">
                <v-item-group selected-class="bg-active" multiple>
                  <v-container>
                    <div class="list-group">
                      <div class="list-row"
                           v-for="(item, i) in members"
                           :key="i"
                      >
                        <div class="list-txt">
                          <v-item>
                            <v-card
                              :class="item.selected?'bg-active':''"
                              dark
                              @click="onClickMemberRow(i, 1)"
                            >
                              <div class="txt">
                                {{item.memberInfo}}
                              </div>
                            </v-card>
                          </v-item>
                        </div>
                      </div>
                    </div>
                  </v-container>
                </v-item-group>
              </div>
            </div>
          </div>
          <div class="dv-ty02">
            <div class="inner scrollbar">
              <div class="form-group col-ty">
                <div class="text-title">{{t('message.targetPerson')}}</div>
                <!--form-row-->
                <div class="form-row" v-if="popupType == '1'">
                  <div class="row">
                    <div class="col">
                      <c-Input v-model="memberId2" v-bind="InputName" :name="'memberId2'" class="size02"/>
                    </div>
                    <div class="col">
                      <Select v-model="posIdx2" v-bind="selectPos"/>
                    </div>
                    <div class="col">
                      <Select v-model="deptIdx2" v-bind="selectDept"/>
                    </div>
                    <div class="col">
                      <Select v-model="shiftYn2" v-bind="selectShift"/>
                    </div>
                    <div class="col">
                      <Select v-model="targetYn2" v-bind="selectTarget"/>
                    </div>
                    <div class="col">
                      <Select v-model="headYn2" v-bind="selectHead"/>
                    </div>
                  </div>
                </div>
                <div class="text-total">{{targetCnt}}{{t('message.selectedCount')}}</div>
              </div>
              <div class="selected-group2">
                <v-item-group selected-class="bg-active" multiple>
                  <v-container>
                    <div class="list-group">
                      <div class="list-row"
                           v-for="(item, i) in targets"
                           :key="i"
                      >
                        <div class="list-txt">
                          <v-item>
                            <v-card
                              :class="item.selected?'bg-active':''"
                              dark
                              @click="onClickMemberRow(i, 2)"
                            >
                              <div class="txt">
                                {{item.memberInfo}}
                              </div>
                            </v-card>
                          </v-item>
                        </div>
                      </div>
                    </div>
                  </v-container>
                </v-item-group>
              </div>
            </div>
          </div>
        </v-card-text>
        <!--버튼-->
        <v-card-actions class=" d-flex justify-end pop-bottom-bg">
          <c-btn02 :btnText="t('message.cancel')" @click="dialog=false"/>
          <c-btn01 :btnText="t('message.save')" @click="handleForm"/>
        </v-card-actions>
      </v-card>
      <v-snackbar v-model="snackbar" :timeout="1000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
    </v-dialog>
</template>

<script setup lang="ts">
import {computed, ref} from 'vue'
import CompanyService from "@/services/company.service";
import MemberService from "@/services/member.service";
import utils from "@/common/Utils";
import _ from 'lodash';
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import debounce from 'lodash/debounce';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const emit = defineEmits(['close', 'confirm'])
const dialog = defineModel()

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
const snackbar = ref(false)
const snackText = ref('')
const memberId = ref('')
const posIdx = ref('')
const deptIdx = ref('')
const shiftYn = ref('')
const targetYn = ref('')
const headYn = ref('')
const memberId2 = ref('')
const posIdx2 = ref('')
const deptIdx2 = ref('')
const shiftYn2 = ref('')
const targetYn2 = ref('')
const headYn2 = ref('')
const memberCnt = ref(0)
const members = ref([])
const targetCnt = ref(0)
const targets = ref([])
const selectDept = ref({items: [{name: t('message.department'), value: ''}]})
const selectPos = ref({items: [{name: t('message.position'), value: ''}]})
const popupType = ref('')

//ui
const btnSave = ref({
  btnText: computed(() => t('message.save')),
})
const InputName = ref({
  type: 'text',
  placeholder: computed(() => t('message.name')),
})
const selectTarget = {items: [{name: t('message.target'), value: ''},{name: 'Y', value: 'Y'},{name: 'N', value: 'N'}]}
const selectHead = {items: [{name: t('message.organizationLeader'), value: ''},{name: 'Y', value: 'Y'},{name: 'N', value: 'N'}]}
const selectShift = ref({items: [{name: t('message.shiftWork'), value: ''}]})

//hook
onBeforeUpdate (()=>{
  members.value = []
  targets.value = []
})

onUpdated(() => {
  popupType.value = storeRef.popupType.value  //역할 : 관찰자,피관찰자
  if(dialog.value)
    getCompanyInfo()
})

onBeforeUnmount(() => {
  debouncedHandleInput1.cancel()
  debouncedHandleInput2.cancel()
})

//watch
const debouncedHandleInput1 = debounce((type)=>{getData(type)}, 1000)
const debouncedHandleInput2 = debounce((type)=>{getData(type)}, 1000)
watch(memberId, (newValue) => {
  debouncedHandleInput1(1)
})
watch(posIdx, (newValue) => {
  getData(1)
})
watch(deptIdx, (newValue) => {
  getData(1)
})
watch(shiftYn, (newValue) => {
  getData(1)
})
watch(targetYn, (newValue) => {
  getData(1)
})
watch(headYn, (newValue) => {
  getData(1)
})
watch(memberId2, (newValue) => {
  debouncedHandleInput2(2)
})
watch(posIdx2, (newValue) => {
  getData(2)
})
watch(deptIdx2, (newValue) => {
  getData(2)
})
watch(shiftYn2, (newValue) => {
  getData(2)
})
watch(targetYn2, (newValue) => {
  getData(2)
})
watch(headYn2, (newValue) => {
  getData(2)
})
watch(members, (newValue) => {
  memberCnt.value = _.filter(members.value, {selected: true}).length
}, {deep: true})
watch(targets, (newValue) => {
  targetCnt.value = _.filter(targets.value, {selected: true}).length
}, {deep: true})

//function
const getCompanyInfo=async()=>{
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    idx: companyIdx,
  }

  try{
    const response:any = await CompanyService.getCompany(params)
    if(response.result){
      let posArr = {items: [{name: t('message.position'), value: ''}]}
      response.result.posList.forEach((item)=>{
        posArr.items.push({name:item.treeName, value:item.idx})
      })
      selectPos.value = posArr

      let deptArr = {items: [{name: t('message.department'), value: ''}]}
      response.result.deptList.forEach((item)=>{
        deptArr.items.push({name:item.treeName, value:item.idx})
      })
      selectDept.value = deptArr

      let shiftArr = {items: [{name: t('message.shiftWork'), value: ''}]}
      response.result.shiftList.forEach((item)=>{
        shiftArr.items.push({name:item.shiftName, value:item.idx})
      })
      selectShift.value = shiftArr
    }

    if(popupType.value == '2')
      await getData(1)
    else
      await getData(2)

    //넘겨진 데이터가 있다면 셋팅
    let popupItems:any = storeRef.popupItems.value
    if(!utils.isEmpty(popupItems)) {
      _.forEach(members.value, function (item) {
        if (item.idx == popupItems.memberIdx)
          item.selected = true
      })
      _.forEach(targets.value, function (item) {
        if (item.idx == popupItems.targetMemberIdx)
          item.selected = true
      })
    }
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

const getData=async(listType)=>{
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {
    companyIdx: companyIdx,
    memberId: listType=='1'?memberId.value:memberId2.value,
    posIdx: listType=='1'?posIdx.value:posIdx2.value,
    deptIdx: listType=='1'?deptIdx.value:deptIdx2.value,
    shiftIdx: listType=='1'?shiftYn.value:shiftYn2.value,
    targetYn: listType=='1'?targetYn.value:targetYn2.value,
    headYn: listType=='1'?headYn.value:headYn2.value,
  }

  try{
    const response = await MemberService.getMemberListFilter(params)
    if(response.result){
      let memberArr = []  //검색데이터
      let targetArr = []  //리더십 타겟 데이터
      _.forEach(response.result, (item)=>{
        memberArr.push({...item, memberInfo:`${item.memberName||t('message.noInfo')}(${item.memberId||t('message.noInfo')}) / ${item.posName||t('message.noInfo')} / ${item.deptName||t('message.noInfo')}`, selected:false})
      })
      //타인관찰 타겟맴버
      const leadershipInfo:any = storeRef.leadershipInfo.value
      const leadershipTargetList = leadershipInfo.leadershipTargets
      _.forEach(leadershipTargetList, (item)=>{
        targetArr.push({...item, memberInfo:`${item.memberName||t('message.noInfo')}(${item.memberId||t('message.noInfo')}) / ${item.posName||t('message.noInfo')} / ${item.deptName||t('message.noInfo')}`, selected:false})
      })

      if(listType == '1') {
        members.value = memberArr
        targets.value = targetArr
      }
      else {
        members.value = targetArr
        targets.value = memberArr
      }
    }
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

function handleForm(){
  if(import.meta.env.MODE == 'development') {
    emit('close', '')
  }
  else{
    const selectedMember = _.filter(members.value, {selected: true})[0]
    const selectedTarget = _.filter(targets.value, {selected: true})[0]
    if(utils.isEmpty(selectedMember) || utils.isEmpty(selectedTarget)){
      snackText.value = '타겟을 선택하세요'
      snackbar.value = true
    }
    else if(selectedMember.idx == selectedTarget.idx){
      snackText.value = '본인은 대상으로 선택할 수 없습니다'
      snackbar.value = true
    }
    else {
      emit('confirm', {memberIdx: selectedMember.idx, memberName: selectedMember.memberName, memberInfo: selectedMember.deptName+'/'+selectedMember.posName, targetMemberIdx: selectedTarget.idx, targetName: selectedTarget.memberName, targetInfo: selectedTarget.deptName+'/'+selectedTarget.posName})
      dialog.value=false
    }
  }
}

function onClickMemberRow(i, listType){
  let list = listType=='1'?members.value:targets.value
  const selected = list[i].selected
  _.forEach(list, function (item){
    item.selected = false
  })
  if(selected)
    list[i].selected = false
  else
    list[i].selected = true
}
</script>


<style lang="scss">

</style>
